import React, { useState, Fragment, useEffect, useCallback } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import SettingTabOrgBusiness from "../ProfileOrg/SettingOrgTabBusiness";
import { useQuery, useMutation } from "@apollo/client";
import {
  useLoginStatus,
  useMyOrgInfo,
} from "../../../Layout/AppMain/LoginStatusContext";

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardHeader,
  Button,
  Modal,
  ModalBody,
} from "reactstrap";
import classnames from "classnames";

import Rating from "@mui/material/Rating";

import {
  GET_ORG_PROFILE,
  CREATE_FAVORITE,
  DELETE_FAVORITE,
  UPDATE_EVALUATION,
} from "../../../queries";
import heartOutline from "../../../../src/assets/utils/images/heart-outline.png";
import heart from "../../../../src/assets/utils/images/heart.png";
import SettingOrgTab1 from "./SettingOrgTab1";
import SettingOrgTab2 from "./SettingOrgTab2";
import SettingOrgTab3 from "./SettingOrgTab3";
import SettingOrgTab4 from "./SettingOrgTab4";
import SettingOrgTab5 from "./SettingOrgTab5";

import { useParams } from "react-router-dom";
import animetionLogo from "../../../assets/utils/images/animetion_logo.gif";
import DissolveBadge from "../../../components/DissolveBadge";

const SettingProfileOrgDashboard = ({
  filterId,
  filterPk,
  orgId,
  userId,
  userRole,
}) => {
  const { orgPageId } = useParams();
  const loginStatus = useLoginStatus();
  const myOrgInfo = useMyOrgInfo();

  //NPSモーダル
  const [modal, setModal] = useState(false);
  const modalToggle = () => setModal(!modal);
  const [thanksScreen, setThanksScreen] = useState(false);
  const [npsVal, setNpsVal] = useState("");
  const [comment, setComment] = useState("");

  //タブ切り替え
  const [activeTab, setActiveTab] = useState("1");
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // 年度変更 state
  const [fiscalYear, setFiscalYear] = useState();

  //クエリ取得
  const { loading, error, data, refetch } = useQuery(GET_ORG_PROFILE, {
    variables: { fiscalYear: fiscalYear, id: orgPageId, userId: userId },
  });

  // ミューテーション
  const [createFav, { data: createdFavId }] = useMutation(CREATE_FAVORITE);
  const [deleteFav, { data: deletedFavId }] = useMutation(DELETE_FAVORITE);
  const [updateEvaluation, { updateResult }] = useMutation(UPDATE_EVALUATION);

  const org_obj =
    data &&
    data.allOrgaccount &&
    data.allOrgaccount.edges[0] &&
    data.allOrgaccount.edges[0].node;

  //お気に入り登録・解除
  const createFavorite = async () => {
    if (loginStatus) {
      await createFav({
        variables: { orgId: org_obj.id, userId: userId },
      });
      await refetch();
    } else {
      alert("お気に入り登録にはログインが必要です。");
      window.location.href = "/#/pages/login";
    }
  };

  const deleteFavorite = async () => {
    await deleteFav({
      variables: { favPk: org_obj.favPk },
    });
    await refetch();
  };

  //評価送信
  const sendEvaluation = async () => {
    if (npsVal === "" || npsVal === null) {
      alert("評価を選択してください");
    } else {
      updateEvaluation({
        variables: {
          userId: userId,
          orgId: org_obj.id,
          evaluation: npsVal,
          comment: comment,
        },
      });
      setThanksScreen(true);
      await refetch();
    }
  };

  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);

  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) {
    alert(error);
    // alert("ログイン制限時間が切れました、再リロードしてください。");

    window.location.href = "/#/dashboards/journy";
    window.location.reload();
  }
  if (!data) return "...Not Found";

  const noDonationUrl = () => {
    alert("この組織は寄付URLをまだ設定しておりません");
  };

  //全年度
  let all_fiscal_year =
    org_obj &&
    org_obj.annualData &&
    org_obj.annualData.edges &&
    org_obj.annualData.edges.map((array) => array.node.fiscalYear);

  if (all_fiscal_year) {
    all_fiscal_year.sort((a, b) => (a > b ? -1 : 1));
  } else {
  }

  //最新年度
  const default_fiscal_year = all_fiscal_year.slice()[0];

  return (
    <div>
      <Fragment>
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Card className="mb-3">
            <CardHeader className="org_title org_prof_title">
              <div style={{ display: "flex", alignItems: "center" }}>
                {org_obj.logoUrl ? (
                  <img
                    src={org_obj.logoUrl}
                    alt=""
                    className="profile-blur opacity-9"
                    style={{ width: "auto", height: "40px" }}
                  />
                ) : (
                  <div></div>
                )}
                <h4
                  className="org_name"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  {org_obj.name}{" "}
                  {org_obj.isDissolve && <DissolveBadge type="heading" />}
                </h4>
              </div>
              {myOrgInfo.id == org_obj.id ? (
                <></>
              ) : (
                <div className="">
                  {org_obj.donationUrl ? (
                    <a href={org_obj.donationUrl}>
                      <Button
                        style={{ marginRight: "15px" }}
                        className="fav_btn_pc fav_btn_off"
                      >
                        寄付する
                      </Button>
                    </a>
                  ) : (
                    <Button
                      onClick={noDonationUrl}
                      style={{ marginRight: "15px" }}
                      className="fav_btn_pc fav_btn_off"
                    >
                      寄付する
                    </Button>
                  )}
                  {org_obj.favPk ? (
                    <>
                      <Button
                        onClick={deleteFavorite}
                        className="fav_btn_pc fav_btn_on"
                      >
                        お気入りから削除
                      </Button>
                      <img
                        src={heart}
                        onClick={deleteFavorite}
                        style={{ width: "25px", cursor: "pointer" }}
                        className="fav_icon_sp"
                      />
                    </>
                  ) : (
                    <>
                      <img
                        src={heartOutline}
                        onClick={() => {
                          createFavorite();
                          if (org_obj.evaluated === false) {
                            modalToggle();
                          }
                        }}
                        style={{ width: "25px", cursor: "pointer" }}
                        className="fav_icon_sp"
                      />

                      <Button
                        onClick={() => {
                          createFavorite();
                          if (org_obj.evaluated === false) {
                            modalToggle();
                          }
                        }}
                        className="fav_btn_pc fav_btn_off"
                      >
                        お気入り登録
                      </Button>
                    </>
                  )}
                </div>
              )}
            </CardHeader>
          </Card>
          <Card className="mb-2 original-card__sp">
            <CardHeader className="card-header-tab">
              <Nav>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    組織概要
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggle("2");
                    }}
                  >
                    ミッションと連携方針
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "3" })}
                    onClick={() => {
                      toggle("3");
                    }}
                  >
                    事業紹介
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "4" })}
                    onClick={() => {
                      toggle("4");
                    }}
                  >
                    財務データ
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "5" })}
                    onClick={() => {
                      toggle("5");
                    }}
                  >
                    情報開示と第三者認証
                  </NavLink>
                </NavItem>
                {myOrgInfo.id == org_obj.id ? (
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "6" })}
                      onClick={() => {
                        toggle("6");
                      }}
                    >
                      契約プランとメンバー
                    </NavLink>
                  </NavItem>
                ) : (
                  <></>
                )}
              </Nav>
            </CardHeader>
          </Card>

          <TabContent activeTab={activeTab} className="card-tab">
            <TabPane tabId="1">
              <SettingOrgTab1
                obj={org_obj}
                refetch={refetch}
                offices={org_obj.offices}
              />
            </TabPane>

            <TabPane tabId="2">
              <SettingOrgTab2
                obj={org_obj}
                loading={loading}
                refetch={refetch}
              />
            </TabPane>
            <TabPane tabId="3">
              <SettingTabOrgBusiness
                obj={org_obj}
                userId={userId}
                refetch={refetch}
                userRole={userRole}
              />
            </TabPane>
            <TabPane tabId="4">
              <SettingOrgTab3
                obj={org_obj}
                all_fiscal_year={all_fiscal_year}
                default_fiscal_year={default_fiscal_year}
                fiscalYear={fiscalYear}
                setFiscalYear={setFiscalYear}
                refetch={refetch}
                orgId={orgPageId}
              />
            </TabPane>
            <TabPane tabId="5">
              <SettingOrgTab4 obj={org_obj} orgPk={orgPageId} />
            </TabPane>
            <TabPane tabId="6">
              <SettingOrgTab5 obj={org_obj} />
            </TabPane>
          </TabContent>
          <Modal isOpen={modal} toggle={modalToggle}>
            <ModalBody
              className="mt-4 ml-3 mr-3 mb-2 npsModal"
              style={{
                boxSizing: "border-box",
              }}
            >
              {thanksScreen ? (
                <div>
                  <p className="bold">コメントありがとうございました。</p>
                  <Button
                    className="ema__btn__main contactBtn"
                    type="submit"
                    onClick={() => setModal(false)}
                    style={{ width: "100%" }}
                  >
                    戻る
                  </Button>
                </div>
              ) : (
                <div>
                  <p className="bold">この組織をどの程度お勧めしますか？</p>
                  <Rating
                    name="unique-rating"
                    value={npsVal}
                    onChange={(event, newValue) => {
                      setNpsVal(newValue);
                    }}
                    max={10}
                  />

                  <textarea
                    className="form-control"
                    style={{
                      marginTop: 5,
                    }}
                    minRows={3}
                    maxRows={3}
                    placeholder="コメント"
                    onChange={(e) => setComment(e.target.value)}
                  />
                  <div style={{ marginTop: 16 }}>
                    <Button
                      className="ema__btn__main contactBtn"
                      type="submit"
                      onClick={sendEvaluation}
                      style={{ width: "100%" }}
                    >
                      送る
                    </Button>
                  </div>
                </div>
              )}
            </ModalBody>
          </Modal>
        </CSSTransitionGroup>
      </Fragment>
    </div>
  );
};

export default SettingProfileOrgDashboard;
